/* HorecaBayim — blog yazısı sayfası (v2.8, 2026-10-08). defer ile yüklenir.
   sections/hb-article.liquid içindekiler listesini sunucuda üretir ve H2'lere
   id verir; bu dosya:
   1. id'si olmayan H2 kalmışsa (editörden özel nitelikle girilmiş) id verir
      ve listeyi tamamlar,
   2. okunan başlığı içindekilerde vurgular (masaüstü yapışkan + mobil liste),
   3. mobil listede bir başlığa gidince listeyi kapatır,
   4. "Linki kopyala" düğmesi.
   JS yoksa: liste ve linkler çalışır, yalnız vurgu ve kopyalama olmaz. */
(function () {
  'use strict';

  var root = document.querySelector('[data-hb-article]');
  if (!root) return;
  var body = root.querySelector('[data-hb-body]');
  var lists = root.querySelectorAll('.hb-toc__list');
  var EN = document.documentElement.getAttribute('data-hb-lang') === 'en';

  function slug(t) {
    var map = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'â': 'a', 'î': 'i', 'û': 'u' };
    return 'b-' + t.toLocaleLowerCase('tr').replace(/[çğıöşüâîû]/g, function (c) { return map[c]; })
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* 1. eksik id'ler */
  var heads = body ? Array.prototype.slice.call(body.querySelectorAll('h2')) : [];
  var added = false;
  heads.forEach(function (h) {
    if (h.id) return;
    var id = slug(h.textContent || '');
    var n = 2, base = id;
    while (document.getElementById(id)) id = base + '-' + n++;
    h.id = id;
    added = true;
  });
  if (added) {
    Array.prototype.forEach.call(lists, function (ol) {
      ol.innerHTML = '';
      heads.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        ol.appendChild(li);
      });
    });
  }

  /* 2. okunan başlığı vurgula */
  var links = root.querySelectorAll('.hb-toc__list a');
  function mark(id) {
    Array.prototype.forEach.call(links, function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }
  if (heads.length && 'IntersectionObserver' in window) {
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
      // görünür alanın üst bandındaki ilk başlık; yoksa en son geçilen
      var current = null;
      for (var i = 0; i < heads.length; i++) {
        if (visible[heads[i].id]) { current = heads[i].id; break; }
      }
      if (!current) {
        for (var j = heads.length - 1; j >= 0; j--) {
          if (heads[j].getBoundingClientRect().top < window.innerHeight * 0.3) { current = heads[j].id; break; }
        }
      }
      if (current) mark(current);
    }, { rootMargin: '-90px 0px -65% 0px', threshold: 0 });
    heads.forEach(function (h) { io.observe(h); });
  }

  /* 3. mobil listede seçimden sonra kapat */
  var mob = root.querySelector('.hb-toc-m');
  if (mob) {
    mob.addEventListener('click', function (e) {
      if (e.target.closest('a')) mob.open = false;
    });
  }

  /* 4. linki kopyala */
  var copy = root.querySelector('[data-hb-copy]');
  var ok = root.querySelector('.hb-share__ok');
  if (copy) {
    copy.addEventListener('click', function () {
      var url = copy.getAttribute('data-hb-copy') || location.href;
      var done = function () {
        if (!ok) return;
        EN = document.documentElement.getAttribute('data-hb-lang') === 'en';
        ok.textContent = EN ? 'Link copied' : 'Link kopyalandı';
        window.clearTimeout(copy._t);
        copy._t = window.setTimeout(function () { ok.textContent = ''; }, 2400);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { fallback(url); done(); });
      } else {
        fallback(url);
        done();
      }
    });
  }
  function fallback(text) {
    var t = document.createElement('textarea');
    t.value = text;
    t.setAttribute('readonly', '');
    t.style.position = 'fixed';
    t.style.opacity = '0';
    document.body.appendChild(t);
    t.select();
    try { document.execCommand('copy'); } catch (err) { /* sessiz */ }
    document.body.removeChild(t);
  }
})();
